export function createAuraReferralForm(payload = {}) {
    const rawName = String(payload.name ?? '').trim();
    const firstName = String(payload.first_name ?? '').trim();
    const lastName = String(payload.last_name ?? '').trim();
    const name = firstName || (lastName && rawName.endsWith(lastName)
        ? rawName.slice(0, -lastName.length).trim()
        : rawName);
    const fullName = [name, lastName].filter(Boolean).join(' ').trim();

    return {
        name: name || lastName,
        last_name: lastName,
        full_name: fullName || name || lastName,
        rut: payload.rut ?? '',
        email: payload.email ?? '',
        code_phone: payload.code_phone ?? '56',
        phone: payload.phone ?? '',
        signatureHash: payload.signatureHash ?? '',
        terms: false,
    };
}

export function createAuraReferralFormWithRut(payload = {}, effectiveRut = null) {
    return createAuraReferralForm({
        ...payload,
        ...(effectiveRut !== null ? { rut: effectiveRut } : {}),
    });
}

export function adoptEffectiveRut(form, response) {
    return {
        ...form,
        rut: response?.rut ?? form?.rut ?? '',
    };
}

export function clearAuraReferralPayload(payload = {}, { source = null } = {}) {
    Object.assign(payload, {
        name: '',
        first_name: '',
        last_name: '',
        full_name: '',
        rut: '',
        email: '',
        code_phone: '56',
        country_code: '56',
        phone: '',
        terms: false,
    });

    if (typeof globalThis.dispatchEvent === 'function' && typeof globalThis.CustomEvent === 'function') {
        globalThis.dispatchEvent(new CustomEvent('aura-referral:visitor-cleared', {
            detail: { source },
        }));
    }

    return payload;
}

export function ensureAuraCountryOption(select, countryCode) {
    if (!select || !countryCode) {
        return;
    }

    const code = String(countryCode).replace(/\D/g, '');
    const optionExists = Array.from(select.options).some(option => option.value === code);

    if (!optionExists) {
        const option = document.createElement('option');
        option.value = code;
        option.textContent = `+${code}`;
        select.append(option);
    }

    select.value = code;
}
